import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd';
import { Subject } from 'rxjs';
import { floatToStringFormat, stringFormatToFloat } from 'src/app/fieldTypes/TextFields';
import { TITLE } from 'src/app/utils/enum';
import { FormFieldInfo } from '../../../../models/forms-response.models';

@Component({
    selector: 'app-component-number',
    templateUrl: './number.component.html',
    styleUrls: ['./number.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NumberComponent implements OnInit, OnChanges, AfterContentChecked {
    @Input() formFieldInfo: FormFieldInfo;
    @Input() formGroup: FormGroup;
    @Input() formData: any;
    @Input() modalTitle:any;

    formFieldConfig: any;
    fieldConfig: any;
    isRequired: boolean;
    name: string;
    hideTitle: boolean;
    isMathRound: boolean;
    subject: Subject<any> = new Subject();
    value = "0";
    input = "";
    maxlength: string = '';
    fieldCode: string;
    tooltip: string;
    fieldDataInfo:any;
    taxCode="";
    formCode="";
    constructor(private nzModalNotification: NzNotificationService, private cdref: ChangeDetectorRef) { }

    ngOnChanges() {
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    ngOnInit(): void {
        try {
            this.formFieldConfig = this.formFieldInfo.formFieldConfig ? JSON.parse(this.formFieldInfo.formFieldConfig) : "";
            this.fieldConfig = this.formFieldInfo.fieldConfig ? JSON.parse(this.formFieldInfo.fieldConfig) : "";
            this.fieldCode = this.formFieldInfo.fieldCode;
            this.fieldDataInfo=this.formFieldInfo;
            this.hideTitle = (this.formFieldConfig && this.formFieldConfig.hideTitle) ? this.formFieldConfig.hideTitle : false;
            this.name = (this.formFieldConfig && this.formFieldConfig.displayText) ? this.formFieldConfig.displayText : this.formFieldInfo.name;
            this.hideTitle = (this.formFieldConfig && this.formFieldConfig.hideTitle) ? this.formFieldConfig.hideTitle : false;
            this.isMathRound = (this.formFieldConfig && this.formFieldConfig.isMathRound) ? this.formFieldConfig.isMathRound : false;
            this.maxlength = (this.fieldConfig && this.fieldConfig.maxlength) ? this.fieldConfig.maxlength : "";
            this.tooltip = this.formFieldConfig && this.formFieldConfig.tooltip ? this.formFieldConfig.tooltip : "";
            this.formCode=localStorage.getItem('FORM_CODE');
            this.taxCode=localStorage.getItem('TAXCODE');
            this.bindingData();
        } catch (error) {
            this.formFieldConfig = JSON.parse('{ "pattern": "" }');
            this.fieldConfig = JSON.parse('{ "keydownPattern": "" }');
        }
    }

    bindingData(){
        if (this.modalTitle == TITLE.ADD_DATA)//This case is: Click icon(+) to open popup
        {
            this.value = (this.formFieldConfig && this.formFieldInfo.defaultValue) ? this.formFieldInfo.defaultValue : this.formFieldConfig.defaultValue ? this.formFieldConfig.defaultValue : "";
        }
        else if (this.modalTitle == TITLE.UPDATE_DATA) { //This case is: Click icon(edit) to open popup
            if (this.formData) {
                let objectData = this.formData;
                const keys = Object.keys(objectData);
                keys.forEach((key) => {
                    if (key == this.formFieldInfo.fieldCode) {
                        let value = objectData[key];
                        this.value = value;
                    }
                });
            }
        }
        else {
            let storageVal = localStorage.getItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+this.fieldCode);
            if (storageVal) {
                this.value = storageVal;
            } else if (this.formData && this.formData[this.fieldCode]) {
                this.value = this.formData[this.fieldCode];
            } else {
                this.value = (this.formFieldConfig && this.formFieldInfo.defaultValue) ? this.formFieldInfo.defaultValue : this.formFieldConfig.defaultValue ? this.formFieldConfig.defaultValue : "";
            }
        }
    }
    
    Calculator(formula, isMathRound) {
        // $(bodyElement).find('#' + obj.fieldCode).attr('style', 'width: 100%;border: solid 1px #a1bad3 !important; width: 100%;');
        var sum = 0;
        if (formula) {
            sum = isMathRound ? Math.round(eval(formula)) : eval(formula);
        }

        if (isNaN(sum) || isFinite(sum)) {
            this.value = "";
        }
        else {
            this.value = floatToStringFormat(stringFormatToFloat(sum));
        }
    }

    SumTable(fieldCode, index) {
        try {
            let sum = document.getElementById(fieldCode).getAttribute('data-value').replace(/[*^'!,]/g, '');
            return sum;
        } catch (error) {
            return 0;
        }
    }

    onChangeNumber(e) {
        this.input = e.target.value;
        if (this.input) {
            let input = this.input;
            var valNumber: any = input.toString().replace(/[\,]/g, '');
            var validate = true;
            let message = "";

            if (this.fieldConfig && this.fieldConfig.keydownPattern) {
                var patternFieldConfig = new RegExp(this.fieldConfig.keydownPattern);
                if (!patternFieldConfig.test(valNumber) && valNumber != "") {
                    validate = false;
                    message = " sai định dạng format";
                }
            }

            if (validate) {
                if (isNaN(valNumber)) {
                    validate = false;
                    message = " sai định dạng format";
                } else {
                    if (valNumber) {
                        if (valNumber.split('.')[1] != undefined && valNumber.split('.')[1] != "") {
                            var valueNumeric = floatToStringFormat(valNumber);
                            this.value = valueNumeric;

                        } else {
                            var valueNumeric = floatToStringFormat(parseFloat(valNumber));
                            if (!valNumber.includes('.')) {
                                this.value = valueNumeric;
                            }
                        }
                    }
                }
            }

            if (!validate) {
                this.nzModalNotification.error("Cảnh báo", "Chuỗi text " + message);
            }
        }
    }

    modelChange() {
        localStorage.setItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ this.fieldCode, this.value);
    }
}